/* assets/variant-popup.js */
(function () {
  function toText(v) {
    if (v == null) return "";
    if (typeof v === "string" || typeof v === "number") return String(v);
    if (typeof v === "object") {
      if (v.name != null) return String(v.name);
      if (v.value != null) return String(v.value);
      if (v.label != null) return String(v.label);
      if (v.title != null) return String(v.title);
      try {
        return String(v);
      } catch (e) {
        return "";
      }
    }
    return String(v);
  }

  function escapeAttr(v) {
    return toText(v)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function money(cents) {
    try {
      return theme.Shopify.formatMoney(
        cents,
        theme.money_format_with_cart_code_preference ||
          theme.money_format ||
          "₹{{amount}}"
      );
    } catch (e) {
      return `₹ ${Math.round((cents || 0) / 100)}`;
    }
  }

  function popupPriceHtml(priceCents, compareAtCents) {
    const price = Number(priceCents || 0);
    const compare = Number(compareAtCents || 0);
    const hasDiscount = compare > price && price > 0;

    if (!hasDiscount) {
      return `<span class="k-reels-vpop__price-current">${money(price)}</span>`;
    }

    const percentOff = Math.round(((compare - price) * 100) / compare);
    return `<span class="k-reels-vpop__price-current">${money(price)}</span> <span class="k-reels-vpop__price-was" style="text-decoration:line-through;opacity:.65;font-weight:500;margin-left:6px;">${money(compare)}</span> <span class="k-reels-vpop__price-off" style="color:#54c064;font-size:12px;font-weight:700;margin-left:6px;">${percentOff}% OFF</span>`;
  }

  function uniq(arr) {
    const out = [];
    const seen = new Set();
    (arr || []).forEach((v) => {
      const t = toText(v);
      if (!t) return;
      const key = t.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      out.push(t);
    });
    return out;
  }

  function normalizeOptions(product) {
    const opts = product && product.options ? product.options : [];
    const out = [];

    if (Array.isArray(opts)) {
      opts.forEach((o) => out.push(toText(o)));
    }

    if (!out.length && Array.isArray(product.options_with_values)) {
      product.options_with_values.forEach((o) => out.push(toText(o.name)));
    }

    return out.filter(Boolean);
  }

  function getVariantOptionsArray(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options.map(toText);
    const arr = [];
    if (variant.option1 != null) arr.push(toText(variant.option1));
    if (variant.option2 != null) arr.push(toText(variant.option2));
    if (variant.option3 != null) arr.push(toText(variant.option3));
    return arr;
  }

  function findVariant(variants, selected) {
    const sel = (selected || []).map((x) => toText(x));
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const opts = getVariantOptionsArray(v);
      if (!opts.length) continue;
      let ok = true;
      for (let j = 0; j < sel.length; j++) {
        if (toText(opts[j]) !== toText(sel[j])) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  function isOptionValuePossible(variants, selected, optIndex, value) {
    const test = (selected || []).map((x) => toText(x));
    test[optIndex] = toText(value);

    return variants.some((v) => {
      if (!v || !v.available) return false;
      const opts = getVariantOptionsArray(v);
      for (let i = 0; i < test.length; i++) {
        if (!test[i]) continue;
        if (toText(opts[i]) !== toText(test[i])) return false;
      }
      return true;
    });
  }

  function isSwatchOptionName(name) {
    const n = toText(name).toLowerCase();
    return n.indexOf("color") > -1 || n.indexOf("polish") > -1;
  }

  function getSwatchLabel(name) {
    const n = toText(name).toLowerCase();
    if (n.indexOf("polish") > -1) return "Polish";
    if (n.indexOf("color") > -1) return "Stone Color";
    return toText(name);
  }

  function toSwatchToken(v) {
    return toText(v).trim().toLowerCase();
  }

  function getProductHandleFromUrl(url) {
    const u = toText(url);
    if (!u) return "";
    const m = u.match(/\/products\/([^/?#]+)/i);
    return m && m[1] ? decodeURIComponent(m[1]) : "";
  }

  async function fetchCartState() {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function syncReelsATCButtonsWithCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const variantIds = new Set();
    const productIds = new Set();
    const handles = new Set();

    cart.items.forEach((it) => {
      variantIds.add(toText(it && it.id));
      productIds.add(toText(it && it.product_id));
      handles.add(toText(it && it.handle));
    });

    document.querySelectorAll(".k-pcard .k-patc").forEach((btn) => {
      const card = btn.closest(".k-pcard");
      if (!card) return;

      const variantId = toText(card.getAttribute("data-variant"));
      const productId = toText(card.getAttribute("data-product-id"));
      const handle = getProductHandleFromUrl(card.querySelector(".k-pimg") && card.querySelector(".k-pimg").getAttribute("href"));

      const inCart =
        (variantId && variantIds.has(variantId)) ||
        (productId && productIds.has(productId)) ||
        (handle && handles.has(handle));

      btn.classList.toggle("is-in-cart", !!inCart);
      btn.textContent = inCart ? "Go to Cart" : "Add to Cart";
    });
  }

  function updateHeaderCartCount(count) {
    const n = Math.max(0, Number(count || 0));
    const iconNodes = document.querySelectorAll(".header-cart .cart-link .cart-link__icon");
    if (!iconNodes.length) return;

    iconNodes.forEach((icon) => {
      let badge = icon.querySelector(".header-cart__count");

      if (n <= 0) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement("span");
        badge.className = "cart-link__count header-cart__count";
        icon.appendChild(badge);
      }

      badge.textContent = String(n);
    });
  }

  function emitCartUpdated() {
    try {
      window.dispatchEvent(new CustomEvent("kReels:cartUpdated"));
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (e) {}
  }

  function isCartMutationRequest(url, method) {
    const u = toText(url);
    const m = toText(method || "GET").toUpperCase();
    if (!u || m === "GET" || m === "HEAD") return false;
    return /\/cart\/(add|change|update|clear)\.js(\?|$)/i.test(u) || /\/cart(\?|$)/i.test(u);
  }

  if (!window.__kReelsCartMutationObserverBound) {
    if (typeof window.fetch === "function") {
      const origFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const method = (init && init.method) || (input && input.method) || "GET";
        const shouldEmit = isCartMutationRequest(url, method);
        return Promise.resolve(origFetch(input, init)).then((res) => {
          if (shouldEmit && res && res.ok) setTimeout(emitCartUpdated, 0);
          return res;
        });
      };
    }

    if (typeof window.XMLHttpRequest !== "undefined") {
      const XHR = window.XMLHttpRequest;
      const origOpen = XHR.prototype.open;
      const origSend = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__kReelsCartMutation = isCartMutationRequest(url, method);
        return origOpen.apply(this, arguments);
      };

      XHR.prototype.send = function () {
        if (this.__kReelsCartMutation && !this.__kReelsCartMutationBound) {
          this.__kReelsCartMutationBound = true;
          this.addEventListener("loadend", function () {
            if (this.status >= 200 && this.status < 300) setTimeout(emitCartUpdated, 0);
          });
        }
        return origSend.apply(this, arguments);
      };
    }

    window.__kReelsCartMutationObserverBound = true;
  }

  let activePopupCartSync = null;
  if (!window.__kReelsVariantPopupCartUpdatedBound) {
    const onCartUpdated = async function () {
      const cart = await fetchCartState();
      if (cart) {
        syncReelsATCButtonsWithCart(cart);
        updateHeaderCartCount(cart.item_count || 0);
      }
      if (typeof activePopupCartSync === "function") activePopupCartSync(cart);
    };
    document.addEventListener("kReels:cartUpdated", onCartUpdated);
    window.addEventListener("kReels:cartUpdated", onCartUpdated);
    window.__kReelsVariantPopupCartUpdatedBound = true;

    // Ensure header count is correct even if CT ajax cart misses a render cycle.
    setTimeout(onCartUpdated, 0);
    setTimeout(onCartUpdated, 350);
  }

  const api = {
    open: function (product, hooks) {
      const pop = document.querySelector(".k-reels-vpop");
      if (!pop) return;

      const bg = pop.querySelector(".k-reels-vpop__bg");
      const sheet = pop.querySelector(".k-reels-vpop__sheet");
      const closeBtn = pop.querySelector(".k-reels-vpop__close");

      const imgA = pop.querySelector(".k-reels-vpop__img");
      const img = pop.querySelector(".k-reels-vpop__img img");
      const titleA = pop.querySelector(".k-reels-vpop__title");
      const sub = pop.querySelector(".k-reels-vpop__sub");
      const priceEl = pop.querySelector(".k-reels-vpop__price");
      const optsWrap = pop.querySelector(".k-reels-vpop__opts");
      const atc = pop.querySelector(".k-reels-vpop__atc");

      if (!bg || !sheet || !closeBtn || !imgA || !img || !titleA || !sub || !priceEl || !optsWrap || !atc) return;

      if (typeof pop.__kReelsPopupCleanup === "function") {
        try {
          pop.__kReelsPopupCleanup();
        } catch (e) {}
      }

      const options = normalizeOptions(product);
      const variants = Array.isArray(product.variants) ? product.variants : [];

      if (!variants.length || !options.length) return;

      const firstAvail = variants.find((v) => v && v.available) || variants[0];
      let selected = getVariantOptionsArray(firstAvail);
      const atcDefaultText = toText(atc.textContent || "Add to Cart") || "Add to Cart";

      function applyPopupATCState(canAdd) {
        atc.classList.remove("is-in-cart");
        atc.textContent = atcDefaultText;
        atc.disabled = !canAdd;
      }

      async function syncWithCart(cart) {
        const c = cart || (await fetchCartState());
        if (c) {
          syncReelsATCButtonsWithCart(c);
        }
        const v = findVariant(variants, selected);
        applyPopupATCState(!!(v && v.available));
        if (hooks && typeof hooks.syncATCButtonsWithCart === "function") {
          try {
            await hooks.syncATCButtonsWithCart();
          } catch (e) {}
        }
      }

      function render() {
        const v = findVariant(variants, selected);

        imgA.href = product.url || "#";
        titleA.href = product.url || "#";

        titleA.textContent = toText(product.title || "");
        const activePrice = v ? v.price : product.price;
        const activeCompareAt = v ? v.compare_at_price : product.compare_at_price;
        priceEl.innerHTML = popupPriceHtml(activePrice, activeCompareAt);

        const parts = [];
        for (let i = 0; i < options.length; i++) {
          const label = toText(options[i]);
          const val = toText(selected[i] || "");
          if (val) parts.push(`${label}: ${val}`);
        }
        sub.textContent = parts.join("   ");

        const imgSrc =
          v && v.featured_image && v.featured_image.src
            ? v.featured_image.src
            : (product.featured_image || "");
        img.src = imgSrc || "";
        img.alt = toText(product.title || "");

        optsWrap.innerHTML = options
          .map((optName, optIndex) => {
            const values = uniq(
              variants.map((vr) => {
                const o = getVariantOptionsArray(vr);
                return o[optIndex];
              })
            );

            const label = toText(optName);
            const current = toText(selected[optIndex] || "");
            const isSwatch = isSwatchOptionName(label);
            const shownLabel = isSwatch ? getSwatchLabel(label) : label;

            return `
              <div class="k-reels-vpop__row" data-opt="${optIndex}">
                <div class="k-reels-vpop__label">${escapeAttr(shownLabel)} : <span class="label__value">${escapeAttr(current)}</span></div>
                <div class="${isSwatch ? "k-reels-vpop__swatches" : "k-reels-vpop__pills"}">
                  ${values
                    .map((val) => {
                      const active = toText(selected[optIndex]) === toText(val);
                      const ok = isOptionValuePossible(variants, selected, optIndex, val);
                      if (isSwatch) {
                        const swatch = toSwatchToken(val);
                        return `<button class="k-reels-vpop__swatch ${active ? "is-active" : ""} ${ok ? "" : "is-disabled"}" type="button" data-val="${escapeAttr(val)}" data-swatch="${escapeAttr(swatch)}" aria-label="${escapeAttr(val)}" title="${escapeAttr(val)}"><span class="k-reels-vpop__swatch-dot" data-swatch="${escapeAttr(swatch)}" aria-hidden="true"></span></button>`;
                      }
                      return `<button class="k-reels-vpop__pill ${active ? "is-active" : ""} ${ok ? "" : "is-disabled"}" type="button" data-val="${escapeAttr(val)}">${escapeAttr(val)}</button>`;
                    })
                    .join("")}
                </div>
              </div>
            `;
          })
          .join("");

        const canAdd = !!(v && v.available);
        atc.dataset.variantId = v ? String(v.id) : "";
        applyPopupATCState(canAdd);
      }

      function close() {
        pop.classList.remove("is-open");
        setTimeout(() => {
          pop.hidden = true;
        }, 220);
        if (typeof pop.__kReelsPopupCleanup === "function") {
          try {
            pop.__kReelsPopupCleanup();
          } catch (e) {}
          pop.__kReelsPopupCleanup = null;
        }
        if (activePopupCartSync === syncWithCart) activePopupCartSync = null;
        if (hooks && typeof hooks.onClose === "function") hooks.onClose();
        document.removeEventListener("keydown", onEsc, true);
      }

      function open() {
        pop.hidden = false;
        requestAnimationFrame(() => pop.classList.add("is-open"));
        render();
        activePopupCartSync = syncWithCart;
        syncWithCart();
        document.addEventListener("keydown", onEsc, true);
      }

      function onEsc(e) {
        if (e.key === "Escape") close();
      }

      const cleanup = [];
      function bind(el, type, handler, options) {
        if (!el) return;
        el.addEventListener(type, handler, options);
        cleanup.push(() => {
          try {
            el.removeEventListener(type, handler, options);
          } catch (e) {}
        });
      }

      pop.__kReelsPopupCleanup = function () {
        while (cleanup.length) {
          const off = cleanup.pop();
          try {
            off();
          } catch (e) {}
        }
      };

      function getVideoIdForCT() {
        if (hooks && typeof hooks.getVideoId === "function") {
          return toText(hooks.getVideoId());
        }
        try {
          return toText(new URL(window.location.href).searchParams.get("k") || "");
        } catch (e) {
          return "";
        }
      }

      bind(bg, "click", close);
      bind(closeBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        close();
      });

      bind(sheet, "click", function (e) {
        e.stopPropagation();
      });

      bind(imgA, "click", function (e) {
        e.preventDefault();
      });

      bind(titleA, "click", function (e) {
        e.preventDefault();
      });

      bind(optsWrap, "click", function (e) {
        const btn = e.target.closest(".k-reels-vpop__pill, .k-reels-vpop__swatch");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        if (btn.classList.contains("is-disabled")) return;

        const row = btn.closest(".k-reels-vpop__row");
        if (!row) return;

        const optIndex = Number(row.getAttribute("data-opt"));
        const val = btn.getAttribute("data-val") || "";

        selected[optIndex] = val;

        const v = findVariant(variants, selected);
        if (!v || !v.available) {
          const next = variants.find((vr) => {
            if (!vr || !vr.available) return false;
            const o = getVariantOptionsArray(vr);
            return toText(o[optIndex]) === toText(val);
          });
          if (next) selected = getVariantOptionsArray(next);
        }

        render();
      });

      bind(atc, "click", async function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = atc.dataset.variantId;
        if (!variantId) return;
        if (atc.dataset.kReelsBusy === "1") return;
        atc.dataset.kReelsBusy = "1";

        atc.disabled = true;

        try {
          // Close immediately on click; cart work continues in background.
          close();

          if (typeof showLoader === "function") showLoader();

          if (hooks && typeof hooks.addToCart === "function") {
            await hooks.addToCart(Number(variantId));
          }

          if (hooks && typeof hooks.onAdded === "function") {
            await hooks.onAdded();
          }

          if (typeof window.kReelsCTProductATC === "function") {
            window.kReelsCTProductATC({
              video_id: getVideoIdForCT(),
              product_id: toText(product && product.id),
              product_title: toText(product && product.title)
            });
          }

          if (typeof window.kReelsCTVideoATC === "function") {
            const currentVariant = findVariant(variants, selected);
            window.kReelsCTVideoATC({
              video_id: getVideoIdForCT(),
              product_id: toText(product && product.id),
              variant_id: variantId,
              product_title: toText((product && product.title) || (product && product.handle) || ""),
              product_sku: toText(currentVariant && currentVariant.sku),
              product_price: toText(currentVariant && currentVariant.price),
              is_crosssell: true,
              platform: window.KushalsNativeCleverTap ? "app" : "web"
            });
          }

          if (typeof window.kReelsRegisterCrossSellAtc === "function") {
            window.kReelsRegisterCrossSellAtc();
          }

          if (hooks && typeof hooks.refreshDrawer === "function") {
            hooks.refreshDrawer();
          } else if (window.mmajaxcart && typeof window.mmajaxcart.AjaxcartRender === "function") {
            window.mmajaxcart.AjaxcartRender();
          }

          const cart = await fetchCartState();
          if (cart) {
            await syncWithCart(cart);
          } else {
            const v = findVariant(variants, selected);
            applyPopupATCState(!!(v && v.available));
          }
          emitCartUpdated();
        } catch (err) {
          console.error(err);
        } finally {
          atc.dataset.kReelsBusy = "0";
          if (typeof closeLoader === "function") closeLoader();
        }
      });

      pop.style.pointerEvents = "auto";
      sheet.style.pointerEvents = "auto";
      bg.style.pointerEvents = "auto";

      open();
    }
  };

  window.KReelsVariantPopup = api;
})();
